import React, { FC, ReactNode } from 'react';
import { ButtonsCont, DarkButtonWrapper } from './CreateSurveyHeader.styles';
import { LightButton, DarkButton, BodyBoldS } from '../../styles/globals';
import Spinner from '../Spinner/Spinner';

interface IHeadButton {
  id: string;
  callToAction: () => void;
  name: string;
  icon: ReactNode;
  loading: boolean;
  disabled?: boolean;
}

interface IHeadActionButtons {
  scroll: boolean;
  light?: IHeadButton;
  dark?: IHeadButton[];
}

const HeadActionButtons: FC<IHeadActionButtons> = ({ scroll, light, dark }) => {
  return (
    <ButtonsCont id="ButtonsCont">
      {light && (
        <LightButton
          onClick={light.callToAction}
          id={light?.id}
          data-testid={light?.id}
          scroll={scroll}
        >
          {light.icon}
          <BodyBoldS>{light.name}</BodyBoldS>
        </LightButton>
      )}
      {dark && (
        <DarkButtonWrapper>
          {dark.map(button => (
            <DarkButton
              key={button.id}
              onClick={button.callToAction}
              id={button.id}
              data-testid={button.id}
              scroll={scroll}
              disabled={button.disabled}
            >
              {button.loading ? (
                <Spinner />
              ) : (
                <>
                  {button.icon}
                  <BodyBoldS>{button.name}</BodyBoldS>
                </>
              )}
            </DarkButton>
          ))}
        </DarkButtonWrapper>
      )}
    </ButtonsCont>
  );
};

export default HeadActionButtons;
